import { env } from "resume-builder-v2-common";
import { useFetchData } from "./use-fetch-data";
export var useResumeEntries = function useResumeEntries(cacheKey) {
  var url = "".concat(env.api, "/v1/resumes");
  var fetchData = useFetchData(url, cacheKey);
  return fetchData;
};